import { NotFound } from "@dgs/core";
import { Route, Routes } from "react-router";
import { DeletionRequestList } from "./DeletionRequestList";
import { DeletionRequestViewPage } from "./DeletionRequestViewPage";

export const DeletionRequestPage = () => {
	return (
		<Routes>
			<Route index element={<DeletionRequestList />} />
			<Route path=":id" element={<DeletionRequestViewPage />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
